// Отделы компании (/departments) — структура компании (дерево департаментов).
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { http } from '@/shared/api/http';
import type { DeepRequired, Schema } from '@/shared/api';

// 08.08.2026 бэк проставил json-теги и развернул sql.Null*: раньше приходило
// { ID, Name: {String,Valid}, ParentID: {Int64,Valid} }, теперь плоский camelCase.
export type Department = Schema<'tasks_module_internal_models.Department'>;

export type DepartmentListResponse = DeepRequired<
  Schema<'internal_handler_http.DepartmentListResponse'>
>;

export const fetchDepartments = async (): Promise<DepartmentListResponse> => {
  const { data } = await http.get('/departments');
  return data;
};

export const useDepartments = () =>
  useQuery({
    queryKey: ['departments'],
    queryFn: fetchDepartments,
    staleTime: 10 * 60 * 1000,
  });

/**
 * Отделы (/departments) в форме { ID, Name } — для дропдаунов выбора отдела.
 * Замена useUserGroups (он отдаёт отфильтрованные рабочие группы пользователя,
 * а нужен полный список отделов компании). Совместима по форме с useUserGroups.
 */
export function useDepartmentGroups() {
  const { data, isLoading } = useDepartments();
  const groups = useMemo(
    () =>
      (data?.result ?? [])
        .map((d) => ({ ID: d.id, Name: (d.name ?? '').trim() }))
        .filter((g) => Number.isFinite(g.ID) && Boolean(g.Name)),
    [data]
  );
  return { groups, isLoading };
}
